// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { CAttachmentBinaryData_abstract } from './../abstract/SagaSchema/CAttachmentBinaryData_abstract';
export class CAttachmentBinaryData extends CAttachmentBinaryData_abstract {}
